'use client';

import useWindowDimensions from '../../hooks/useWindowDimensions';
import AppNavBarLayout from './AppNavBarLayout';
import Logo from '../Logo';
import Link from 'next/link';
import PropertySearch from '../search/PropertySearch';
import LoginPopover from '../LoginPopover';
import { useState } from 'react';
import NoSsr from 'react-no-ssr';
import SvgIcon from '../icons/SvgIcon';

type Props = {};

export default function DefaultAppNavBar({}: Props) {
  const { isMobile } = useWindowDimensions();
  const [isSearchMode, setIsSearchMode] = useState(false);

  if (isMobile) {
    return (
      <AppNavBarLayout>
        {isSearchMode ? (
          <div className="flex flex-row items-center flex-1">
            <button onClick={() => setIsSearchMode(false)}>
              <SvgIcon name={'HiChevronLeft'} className="text-gray-500 mr-2" />
            </button>
            <PropertySearch />
          </div>
        ) : (
          <>
            <Link
              href={'/m'}
              legacyBehavior={false}
              className="flex items-center flex-1"
            >
              <SvgIcon name={'TbMap'} className="text-gray-500 mr-2" />
              Map
            </Link>

            <Link
              href={'/m'}
              legacyBehavior={false}
              className="flex items-center justify-center flex-1"
              aria-label={'Home'}
            >
              <Logo size={24} showText={true} />
            </Link>
            <div
              className="flex items-center flex-1 justify-end"
              onClick={() => {
                setIsSearchMode(true);
              }}
            >
              <SvgIcon
                name={'HiMagnifyingGlass'}
                className="text-gray-500 mr-2"
              />
              Search
            </div>
          </>
        )}
      </AppNavBarLayout>
    );
  } else {
    return (
      <AppNavBarLayout>
        <Link href={'/m'} legacyBehavior={false} className="flex items-center">
          <Logo size={24} showText={true} />
        </Link>
        <div
          className="w-full ml-4 md:mx-4 lg:mx-40 xl:mx-64"
          style={{ maxWidth: '60rem' }}
        >
          <PropertySearch />
        </div>
        <NoSsr>
          <LoginPopover />
        </NoSsr>
      </AppNavBarLayout>
    );
  }
}
